export default "__VITE_ASSET__DTHriAa3__"